import { List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { Link } from 'gatsby';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React from 'react';

import { navbar_links } from '../../consts/Navbar/links';

export default function MobileNavbarLinks() {
  const { t } = useTranslation();

  return (
    <List disablePadding>
      {navbar_links.map((link) => (
        <ListItem key={link.text} sx={{ marginBottom: '12px' }} disablePadding>
          <ListItemButton
            component={Link} // Use Link as the component for ListItemButton
            to={link.to}
            sx={{ padding: '12px 8px' }}
          >
            <ListItemText primary={t(`${link.i18n}`)} sx={{ margin: 0, fontSize: 16 }} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
}
